import { EditorState, Transaction } from 'prosemirror-state'
import { AddMarkStep, Mapping, RemoveMarkStep, ReplaceAroundStep, ReplaceStep } from 'prosemirror-transform'
import { trackAddMarkStep } from './trackAddMarkStep'
import { trackRemoveMarkStep } from './trackRemoveMarkStep'
import { trackReplaceAroundStep } from './trackReplaceAroundStep'
import { trackReplaceStep } from './trackReplaceStep'
import { getContext } from './utils'

interface StepTrackerProps {
  originalTr: Transaction
  wrappedTr: Transaction
  map: Mapping
  state: EditorState
  userId: number
}

export function stepTracker({ originalTr, wrappedTr, map, state, userId }: StepTrackerProps) {
  const context = getContext(originalTr)

  originalTr.steps.forEach((step, index) => {
    if (step instanceof ReplaceStep) {
      trackReplaceStep(step, userId, state, originalTr, wrappedTr, map, index, context)
    } else if (step instanceof ReplaceAroundStep) {
      trackReplaceAroundStep(step, userId, state, wrappedTr, map, index, context)
    } else if (step instanceof AddMarkStep) {
      trackAddMarkStep(step, userId, state, wrappedTr, map, context)
    } else if (step instanceof RemoveMarkStep) {
      trackRemoveMarkStep(step, userId, state, wrappedTr, context)
    } else {
      wrappedTr.step(step)
    }
  })
}
